import { addOrUpdateKeyInOmnisearch, removeKeyInOmnisearch } from "utils/omnisearchUtils";

/** A stat card's link: the current search with its group's filters replaced by the card's own. */
export function statCardHref(
  search: string,
  groupKeys: readonly string[],
  keyValues: [string, string][],
  location: Pick<Location, "pathname" | "search"> = window.location
): string {
  let next = search;
  for (const key of groupKeys) next = removeKeyInOmnisearch(next, key);
  for (const [key, value] of keyValues) next = addOrUpdateKeyInOmnisearch(next, key, value);
  const params = new URLSearchParams(location.search);
  if (next.trim()) params.set("omnisearch", next.trim());
  else params.delete("omnisearch");
  const query = params.toString();
  return `${location.pathname}${query ? `?${query}` : ""}`;
}
